module.exports = __webpack_public_path__ + "static/sport/login-btn.c1866f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/login-btn.png
// module id = KYOH
// module chunks = 0